<!--
 * Copyright © 2020-2024 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-04-23 19:20:54
-->
<template>
  <NavBar
    v-if="showHeader"
    :title="languages.i_verification_result || 'Verify Result'"
    backgroundColor="#FFFFFF"
    titleColor="#222222"
    arrowColor="#222222"
    @click-left="handleGoBack"
  />
  <div
    v-if="!networkError"
    class="container"
    :dir="isRTL ? 'rtl' : 'ltr'"
    @click="handleCloseSelector"
  >
    <div>
      <div v-if="showQuestionnaireBar" class="questionnaire-bar">
        <div class="bar-left">
          <div class="close-box">
            <img src="./assets/close.png" alt="" @click="closeBar" />
          </div>
          {{ languages.i_photo_code_survey_q }}
        </div>
        <div class="bar-right">
          <img
            class="like-icon"
            src="./assets/like.png"
            alt=""
            @click="openQuestionnaire('positive')"
          />
          <img
            src="./assets/not_like.png"
            alt=""
            @click="openQuestionnaire('negative')"
          />
        </div>
      </div>
      <div class="header">
        <div class="logo-wrapper" @click="handleClickLogo">
          <img src="./assets/logo.png" class="logo" />
          <span class="name">Timemark</span>
        </div>

        <div
          class="selector-wrapper"
          @click="(e) => e.stopPropagation()"
          :class="{
            open: openDropdown
          }"
        >
          <div class="selector" @click="handleClickSelector">
            {{ local.toUpperCase() }}
            <img src="./assets/down.png" class="down" />
          </div>

          <div class="dropdown" @click="handleSelectLang">
            <div class="item" value="EN">English</div>
            <div class="item" value="ID">Indonesia</div>
            <div class="item" value="MS">Melayu</div>
            <div class="item" value="VI">Tiếng Việt</div>
            <div class="item" value="TH">ภาษาไทย</div>
            <div class="item" value="PT">Português</div>
            <div class="item" value="ES">Español</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loading" class="loading-container">
      <van-loading size="24px" vertical>loading...</van-loading>
    </div>
    <div v-else ref="scrollElementRef" class="body-container">
      <div class="result-card">
        <div v-if="status === 0" class="result result-success">
          <div class="top">
            <img class="left-icon" src="./assets/success_icon.png" alt="" />
            <div class="right">
              <div class="verify-result-des">
                {{ languages.i_check_result_title }}
              </div>
              <div class="verify-result">{{ languages.i_authentic }}</div>
            </div>
            <div
              class="verify-share-icon"
              :style="{ transform: isRTL ? 'scaleX(-1)' : 'scaleX(1)' }"
              @click="handleClickShareIcon"
            />
          </div>
          <div class="middle">
            <div class="code-box">
              <div class="code-box-left">
                {{ languages.i_photo_code }}
              </div>
              <div class="code-box-right">
                {{ code }}
              </div>
            </div>
            <div class="result-detail">
              <div class="result-info-item">
                <div class="key">{{ languages.i_app }}</div>
                <div class="value">Timemark Camera</div>
              </div>
              <div v-if="photoInfo.deviceModel" class="result-info-item">
                <div class="key">{{ languages.i_photo_code_device }}</div>
                <div class="value">{{ photoInfo?.deviceModel }}</div>
              </div>
              <div v-if="photoInfo?.timestamp" class="result-info-item">
                <div class="key">{{ languages.i_time }}</div>
                <div class="value">{{ time || '- -' }}</div>
              </div>
              <div class="result-info-item">
                <div class="key">{{ languages.i_date }}</div>
                <div class="value">{{ date || '- -' }}</div>
              </div>
              <div class="result-info-item">
                <div class="key">{{ languages.i_gps }}</div>
                <div class="value">
                  {{ photoInfo?.lat ? `${photoInfo?.lat},` : '-' }}
                  {{ photoInfo?.lng || '-' }}
                </div>
              </div>
              <div class="result-info-item">
                <div class="key">{{ languages.i_location }}</div>
                <div class="value" v-if="mapImage">
                  <div v-if="mapImage" class="map-container">
                    <img
                      v-if="mapImage"
                      class="mapImage"
                      :src="'data:image/png;base64,' + mapImage"
                      alt=""
                    />
                    <img
                      class="location-icon"
                      src="./assets/icon-location.png"
                      alt=""
                    />
                  </div>
                  <div class="opne-map" @click="handleRedirectToGoogleMaps">
                    {{ languages.i_open_in_map }} >
                  </div>
                </div>
                <div v-else :style="{ fontWeight: 400, fontSize: '18px' }">
                  {{ '- -' }}
                </div>
              </div>
            </div>
          </div>
          <div class="bottom">
            {{ languages.i_anti_Cheat_Lab }}
          </div>
        </div>

        <div v-if="[2, 3].includes(status)" class="result result-failed">
          <div class="top">
            <img class="left-icon" src="./assets/failed_icon.png" alt="" />
            <div class="right">
              <div class="verify-result-des">
                {{ languages.i_check_result_title }}
              </div>
              <div class="verify-result">{{ languages.i_not_found }}</div>
            </div>
            <div
              class="verify-share-icon"
              :style="{ transform: isRTL ? 'scaleX(-1)' : 'scaleX(1)' }"
              @click="handleClickShareIcon"
            />
          </div>
          <div class="middle">
            <div class="code-box">
              <div class="code-box-left">
                {{ languages.i_photo_code }}
              </div>
              <div class="code-box-right">
                {{ code }}
              </div>
            </div>
            <div class="result-detail">
              <span v-if="status === 3">{{
                languages.i_unable_cheating_tampering
              }}</span>
              <span v-else>{{ languages.i_photo_code_fake }}</span>
            </div>
          </div>
          <div class="bottom result-failed-bottom">
            {{ languages.i_anti_Cheat_Lab }}
          </div>
        </div>

        <div v-if="status === 1" class="result result-invalid">
          <div class="title">{{ languages.i_photo_code_invalid }}</div>
          <div class="desc">
            {{ languages.i_photo_code_invalid_content }}
          </div>
        </div>
      </div>
      <div class="content">
        <div class="faqs">FAQS</div>
        <div class="content-item">
          <div class="content-title">
            {{ languages.i_photo_code_authenticity }}
          </div>
          <div class="content-content">
            {{ languages.i_photo_code_authenticity_content }}
          </div>
        </div>
        <div class="content-item">
          <div class="content-title">
            {{ languages.i_photo_code_guarantee_authenticity }}
          </div>
          <div class="content-content">
            <div class="content-info">
              <span class="content-info-key">{{
                languages.i_h5_anti_fake_time
              }}</span>
              <span class="content-info-value">
                {{ languages.i_h5_anti_fake_time_content }}
              </span>
            </div>
            <div class="content-info">
              <span class="content-info-key">{{
                languages.i_h5_anti_fake_gps
              }}</span>
              <span class="content-info-value">
                {{ languages.i_h5_anti_fake_gps_content }}
              </span>
            </div>
            <div class="content-info">
              <span class="content-info-key">
                {{ languages.i_photo_code }}:
              </span>
              <span class="content-info-value">
                {{ languages.i_photo_code_content }}
              </span>
            </div>
          </div>
        </div>
        <div class="content-item">
          <div class="content-title">{{ languages.i_use_photo_code }}</div>
          <div class="content-content">
            <div class="content-info">
              <div class="content-info-key info-title">
                {{ languages.i_turn_on_photo_code }}
              </div>
              <div class="content-info-value">
                {{ languages.i_turn_photocode_content1 }}
              </div>
              <div class="content-info-value">
                {{ languages.i_turn_photocode_content2 }}
              </div>
            </div>
            <img src="./assets/example1.png" alt="" />
            <div class="content-info">
              <div class="content-info-key info-title">
                {{ languages.i_verify_photo_code }}
              </div>
              <div class="content-info-value">
                {{ languages.i_verify_photo_code_content }}
              </div>
            </div>
            <img src="./assets/example2.png" alt="" />
          </div>
        </div>
        <div class="link-wrapper">
          <div class="learning">{{ languages.i_h5_contact }}</div>
          <div class="apps">
            <img
              v-for="(item, index) in apps"
              :key="index"
              :src="item.img"
              class="app-icon"
              @click="handleOpenApp(item)"
            />
          </div>
        </div>

        <div
          ref="downloadRef"
          class="download-btn-1"
          @click="handleDownload('downloadDown')"
        >
          <img src="./assets/ios.png" class="sys-icon" />
          <img src="./assets/android.png" class="sys-icon android" />
          {{ languages.i_download_now }}
        </div>
      </div>
    </div>
  </div>
  <div v-else class="networkErr">
    <div class="content-title">{{ languages.i_page_network_exception }}</div>
    <div class="content-des">{{ languages.i_check_net_and_try_again }}</div>
    <button class="content-btn" @click="handleRetry">
      {{ languages.i_try_again }}
    </button>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { getDefaultLocale } from '@/pages/global/utils/locale'
import lang from './lang.json'
import getUA from '../../../utils/getUA'
import todayAxios from '../../../utils/global/todayAxiosGlobal'
import parseQueryString from '../../../utils/parseQueryString'
import NavBar from '@/pages/global/components/HeyNavBar/index.vue'

import whatsapp from './assets/whatsapp.png'
import zalo from './assets/zalo.png'
import messenger from './assets/messenger.png'
import mail from './assets/mail.png'
import sa from '../../../utils/saUtilsGlobal'
import { Toast } from 'vant'
import { formatVersionCode } from '@utils/utils'
import { mapVersionCode } from '../../../utils/global/versionUtils'
import { isInApp } from '@utils/todayUtils'

// import { unix } from 'moment'
const moment = require('moment-timezone')

const appStoreURL =
  'https://apps.apple.com/app/apple-store/id6446071834?pt=126093046&ct=timemark_official_h5_introduce&mt=8'
const apkURL =
  'https://play.google.com/store/apps/details?id=com.oceangalaxy.camera.new&referrer=utm_source%3Dtimemark_official_h5_introduce'
const query = parseQueryString()
const UA = getUA()
const defaultLocal = getDefaultLocale()
const local = ref(defaultLocal)
const networkError = ref(false)
const showQuestionnaireBar = ref(true)
const languages = new Proxy(lang, {
  get: function (target, property) {
    if (target[property]) {
      return target[property][local.value] || target[property].en
    }

    return ''
  }
})

// 检测是否为阿拉伯语（RTL语言）
const isRTL = ref(defaultLocal === 'ar')

const showHeader = computed(() => isInApp && query.fromPlace === 'verifyCenter')

/**
 * 动态添加meta标签
 * <meta name="description" content="">
 */
const descMeta = document.createElement('meta')
descMeta.setAttribute('name', 'description')
descMeta.setAttribute(
  'content',
  languages.i_timemark_slogan.replace(/\n/g, ' ')
)
document.querySelector('head').appendChild(descMeta)

const apps = [
  {
    img: whatsapp,
    url: 'https://chat.whatsapp.com/L1jLkNjBEy1AiYvTe3CSxV',
    name: 'whatsapp'
  },
  {
    img: zalo,
    url: 'https://zalo.me/g/aqadto479',
    name: 'zalo'
  },
  {
    img: messenger,
    url: 'https://m.me/timemarkcamera',
    name: 'messenger'
  },
  {
    img: mail,
    url: 'mailto:timemarkofficial@gmail.com',
    name: 'mail'
  }
]

const code = ref('')
const pageInTime = ref(0)
const scrollElementRef = ref(null)
const downloadRef = ref(null)

onMounted(() => {
  pageInTime.value = new Date().getTime()
  const pathname = window.location.pathname
  code.value = pathname.split('/')[2]
  getQueryInfo()
  handleSaTrack('enter')
  window.addEventListener('beforeunload', handleBeforeUnload)
})
// 在组件卸载前移除事件监听器
onBeforeUnmount(() => {
  const pageHeight = scrollElementRef.value.scrollHeight
  const scrollHeight =
    scrollElementRef.value.scrollTop + scrollElementRef.value.offsetHeight
  const ratio = (scrollHeight / pageHeight).toFixed(1)
  handleSaTrack('back', {
    processTime: parseInt((new Date().getTime() - pageInTime.value) / 1000),
    ratio: ratio,
    isShownDownload: scrollHeight + 50 >= downloadRef.value.offsetTop
  })
  window.removeEventListener('beforeunload', handleBeforeUnload)
})

const handleBeforeUnload = (event) => {
  // 执行一些清理操作或保存数据
  event.preventDefault()
  event.returnValue = ''
  const pageHeight = scrollElementRef.value.scrollHeight
  const scrollHeight =
    scrollElementRef.value.scrollTop + scrollElementRef.value.offsetHeight
  const ratio = (scrollHeight / pageHeight).toFixed(1)
  handleSaTrack('back', {
    processTime: parseInt((new Date().getTime() - pageInTime.value) / 1000),
    ratio: ratio,
    isShownDownload: scrollHeight + 50 > downloadRef.value.offsetTop,
    content: code.value
  })
}

const closeBar = () => {
  handleSaTrack('close')
  showQuestionnaireBar.value = false
}
const openQuestionnaire = (type) => {
  window.removeEventListener('beforeunload', handleBeforeUnload)
  let url = 'https://forms.gle/Q2odpj3uooSnUJuo6'
  switch (local.value) {
    case 'en':
      url = 'https://forms.gle/Q2odpj3uooSnUJuo6'
      break
    case 'vi':
      url = 'https://forms.gle/djgHtvmD8gEVoDo56'
      break
    case 'id':
      url = 'https://forms.gle/2jKSwY6ASHgdyPLd8'
      break
    case 'es':
      url = 'https://forms.gle/SwVyZjKGxzho4oH27'
      break
    case 'pt':
      url = 'https://forms.gle/64xTHBLRbnBqznww5'
      break
    default:
      url = 'https://forms.gle/Q2odpj3uooSnUJuo6'
      break
  }
  handleSaTrack(type, {
    url: url
  })
  window.location.href = url
}

const handleClickLogo = () => {
  handleSaTrack('appIcon')
  window.removeEventListener('beforeunload', handleBeforeUnload)
  window.location.href = 'https://timemark.com'
}

const handleGoBack = () => {
  window.history.back()
}

const openDropdown = ref(false)
const handleClickSelector = () => {
  openDropdown.value = !openDropdown.value
}

const handleCloseSelector = () => {
  openDropdown.value = false
}

const handleSelectLang = (e) => {
  if (e.target.className === 'item') {
    local.value = e.target.getAttribute('value').toLowerCase()
    openDropdown.value = false
    handleSaTrack('changeLanguage', { changeLanguage: local.value })
  }
}

const handleDownload = (actionType) => {
  handleSaTrack(actionType)
  window.location.href = UA.isIOS ? appStoreURL : apkURL
}

const handleOpenApp = (item) => {
  handleSaTrack('connect', { channel: item.name })
  window.location.href = item.url
}

const handleRetry = () => {
  handleSaTrack('retry')
  networkError.value = false
  getQueryInfo()
}

const handleRedirectToGoogleMaps = () => {
  handleSaTrack('map')
  try {
    const lat = photoInfo.value.lat
    const lng = photoInfo.value.lng
    const url = `https://www.google.com/maps?q=${lat},${lng}`
    console.log('url', url)
    window.location.href = url
  } catch (error) {
    console.log('tps://www.google.com/map', error)
  }
}

const photoInfo = ref({})
const status = ref(0)
const time = ref('')
const date = ref('')
const mapImage = ref('')
const loading = ref(false)

const getQueryInfo = async () => {
  try {
    loading.value = true
    let res = await todayAxios.post('/next/photo/code/location/query', {
      photoCode: code.value
    })
    loading.value = false
    res = res.data
    if (res.code === 200) {
      status.value = res.data.status
      photoInfo.value = {
        ...res.data.photoInfo,
        versionCode: mapVersionCode(Number(res.data.photoInfo.versionCode || 0))
      }
      mapImage.value = res.data.photoInfo.location
      handleSaTrack('loadFinish', {
        content: code.value,
        resultInfo: res.data.status
      })
    }
    const { timestamp, timezoneID } = res.data.photoInfo
    if (timestamp) {
      date.value = moment.unix(timestamp).tz(timezoneID)?.format('YYYY/MM/DD')
      time.value = moment.unix(timestamp).tz(timezoneID)?.format('HH:mm')
    }
  } catch (e) {
    console.log(e)
    loading.value = false
    networkError.value = true
  }
}
const convertUTCToLocal = (utcTimestamp, targetTimeZone) => {
  const date = new Date(utcTimestamp)
  const localDate = new Date(
    date.toLocaleString('en-US', { timeZone: targetTimeZone })
  )
  return localDate
}

/**
 * 点击分享按钮
 * */
const handleClickShareIcon = () => {
  handleSaTrack('share')
  const shareUrl = new URL(window.location.href)
  shareUrl.searchParams.set('fromPlace', 'share')
  let text = `${languages.i_link_verified_result}: ${shareUrl.toString()}`
  navigator.clipboard.writeText(text).then(() => {
    Toast.success(`${'link copied'}`)
  })
}

const handleSaTrack = (actionType, params = {}) => {
  try {
    let loadResult = ''
    if (status.value === 0) {
      loadResult = 'successful'
    } else if (status.value === 1) {
      loadResult = 'notValid'
    } else {
      loadResult = 'notFound'
    }
    if (networkError.value) {
      loadResult = 'networkException'
    }
    const countryCode = navigator.language.split('-')[1]
    const allParams = {
      actionType,
      language: defaultLocal,
      chooseLanguage: local.value,
      loadResult: loadResult,
      fromPlace: query.fromPlace || 'other',
      type: 'photoCode',
      countryCode: countryCode,
      antiCode: code.value,
      versionCode: Number(photoInfo.value.versionCode || 0),
      ...params
    }
    sa.track('H5_get_action_page_share_photo_code_result', allParams)
    // eslint-disable-next-line no-undef
    gtag('event', 'H5_get_action_page_share_photo_code_result', allParams)
  } catch (error) {
    console.log('error', error)
  }
}
</script>

<style>
body,
h1,
h2,
h3,
h4,
p {
  padding: 0;
  margin: 0;
}

* {
  box-sizing: border-box;
  -webkit-user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

body {
  font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
    Arial, PingFang SC-Light, Microsoft YaHei;
  touch-action: manipulation;
  overflow-x: hidden;
}

@font-face {
  font-family: BigShoulders;
  src: url('./assets/font/BigShouldersDisplay-Medium.ttf');
  font-display: fallback;
}

@font-face {
  font-family: RobotoCondensed;
  src: url('./assets/font/RobotoCondensed-VariableFont_wght.ttf');
  font-display: fallback;
}
</style>

<style lang="scss" scoped>
.container {
  margin: 0 auto;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #1d5689;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  font-family: 'SF Pro Text', 'SF Pro Icons', 'Helvetica Neue', 'Helvetica',
    'Arial', sans-serif;

  .questionnaire-bar {
    padding: 6px 20px 6px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #8fcaf2;
    .bar-left {
      font-size: 14px;
      font-weight: 590;
      color: #144672;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      line-height: 17px;
      .close-box {
        height: 16px;
        width: 16px;
        padding-left: 2px;
        margin-right: 12px;
        box-sizing: border-box;
      }
      img {
        height: 11px;
        width: 11px;
      }
    }
    .bar-right {
      min-width: 80px;
      text-align: end;
      font-size: 0;
      img {
        height: 28px;
        width: 28px;
      }
      .like-icon {
        margin-right: 12px;
      }
    }
  }
  .header {
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    justify-content: space-between;

    .logo-wrapper {
      display: flex;
      align-items: center;

      .logo {
        width: 34px;
        height: 34px;
        margin-right: 8px;
      }

      .name {
        font-size: 18px;
        font-weight: 590;
        color: #fff;
      }
    }

    .selector-wrapper {
      position: relative;

      &.open {
        .dropdown {
          max-height: 420px;
          box-shadow: 0px 2px 8px 0px #00000033;
        }

        .down {
          transform: rotate(180deg);
        }
      }

      .selector {
        width: Fixed (46px) px;

        height: 24px;
        width: 46px;
        display: flex;
        align-items: center;
        padding: 3px 8px 3px 8px;
        border-radius: 12px;
        font-size: 14px;
        font-weight: 400;
        line-height: 17px;
        color: rgba(205, 205, 205, 1);
        background: rgba(227, 230, 239, 0.2);
        justify-content: space-between;

        .down {
          width: 6px;
          height: 3px;
          margin-left: 5px;
          transition: transform 0.2s ease;
        }
      }

      .dropdown {
        position: absolute;
        max-height: 0;
        z-index: 10;
        overflow: hidden;
        transition: max-height 0.2s ease;
        background: #1d5689;
        padding: 8px;
        right: 0;

        .item {
          width: 108px;
          height: 48px;
          display: flex;
          align-items: center;
          padding-left: 16px;
          font-family: PingFang SC;
          font-size: 16px;
          font-weight: 400;
          color: rgba(205, 205, 205, 1);
        }
      }
    }
  }
  .loading-container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .body-container {
    padding-top: 22px;
    flex: 1;
    overflow-y: auto;
  }

  .result-card {
    padding: 0 20px;
    margin-bottom: 40px;
    .result {
      border-radius: 4px;
      .top {
        width: 100%;
        background-color: rgba(120, 120, 120, 1);
        height: 76px;
        padding: 15px;
        display: flex;
        box-sizing: border-box;
        justify-content: flex-start;
        .left-icon {
          height: 46px;
          width: 46px;
          // margin-right: 14px;
        }
        .right {
          flex-grow: 1;
          margin: 0 14px;
          .verify-result-des {
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.7);
            line-height: 17px;
            margin-bottom: 4px;
          }
          .verify-result {
            font-size: 20px;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            line-height: 24px;
          }
        }
        .verify-share-icon {
          width: 32px;
          height: 32px;
          background: url('./assets/share_icon.png') no-repeat center center;
          background-size: 100% 100%;
        }
      }
      .middle {
        background-color: #fff;
        box-sizing: border-box;
        padding: 30px 20px;
        .code-box {
          display: flex;
          justify-content: flex-start;
          height: 36px;
          margin-bottom: 16px;
          .code-box-left {
            font-family: 'RobotoCondensed';
            padding: 8px;
            font-size: 15px;
            line-height: 20px;
            font-weight: 400;
            background: rgba(214, 214, 214, 1);
            color: rgba(85, 85, 85, 1);
          }
          .code-box-right {
            flex: 1;
            font-family: 'RobotoCondensed';
            text-align: center;
            background: rgba(85, 85, 85, 1);
            padding: 8px;
            font-size: 18px;
            line-height: 22px;
            color: #fff;
          }
        }
        .result-detail {
          font-family: 'RobotoCondensed';
          margin-left: 2px;
          font-size: 20px;
          font-weight: 500;
          line-height: 23.44px;
          margin-bottom: 29px;
        }
      }
      .bottom {
        background: rgba(245, 245, 245, 1);
        padding: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'BigShoulders';
        color: rgba(182, 182, 182, 1);
        font-weight: 500;
        font-size: 14px;
        img {
          width: 119px;
          height: 17px;
        }
      }
      .result-failed-bottom {
        color: rgba(207, 207, 207, 1);
      }
    }
    .result-success {
      .top {
        background: rgba(36, 179, 67, 1);
      }
      .middle {
        .code-box {
          margin-bottom: 40px;
          .code-box-left {
            font-family: 'RobotoCondensed';
            background: rgba(197, 239, 206, 1);
            color: rgba(14, 126, 39, 1);
          }
          .code-box-right {
            font-family: 'RobotoCondensed';
            background: rgba(14, 126, 39, 1);
          }
        }
        .result-detail {
          margin-bottom: 2px;
        }
        .result-info-item {
          margin-bottom: 18px;
          display: flex;
          justify-content: flex-start;
          .key {
            width: 98px;
            font-family: 'RobotoCondensed';
            font-size: 16px;
            font-weight: 400;
            line-height: 18.75px;
            text-align: left;
            color: rgba(119, 119, 119, 1);
          }
          .value {
            flex: 1;
            font-family: 'RobotoCondensed';
            font-size: 16px;
            font-weight: 400;
            line-height: 18.75px;
            text-align: left;
            color: #000;
            .map-container {
              position: relative;
              margin-bottom: 4px;
              width: fit-content;
              .mapImage {
                height: 146px;
                width: 146px;
              }
              .location-icon {
                position: absolute;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                height: 40px;
                width: 40px;
              }
            }
            .opne-map {
              font-family: 'RobotoCondensed';
              font-size: 14px;
              font-weight: 700;
              line-height: 16.71px;
              text-align: left;
              color: rgba(91, 106, 145, 1);
            }
          }
        }
        .result-info-item:last-of-type {
          margin-bottom: 0;
        }
      }
    }

    .result-invalid {
      margin: 84px 0 114px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .title {
        font-size: 24px;
        font-weight: 590;
        line-height: 28.64px;
        text-align: center;
        color: #fff;
        margin-bottom: 10px;
      }
      .desc {
        width: 297px;
        font-size: 16px;
        font-weight: 590;
        line-height: 19px;
        text-align: center;
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 20px;
    .faqs {
      margin-bottom: 10px;
      text-align: center;
      font-size: 18px;
      font-weight: 600;
      line-height: 22px;
      color: #c8ddf0;
    }
    .content-item {
      width: 100%;
      margin-bottom: 22px;
      border: 1px solid #3e7bb3;
      .content-title {
        background: #3e7bb3;
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        line-height: 19px;
        // text-align: left;
        padding: 12px 16px;
      }
      .content-content {
        padding: 12px 16px;
        color: rgba(255, 255, 255, 0.8);
        font-size: 14px;
        font-weight: 400;
        line-height: 16.7px;
        .content-info {
          margin-bottom: 12px;
          .info-title {
            margin-bottom: 6px;
          }
          .content-info-key {
            font-weight: 700;
          }
          .content-info-value {
            line-height: 16.7px;
          }
        }
        img {
          width: 303px;
          margin-bottom: 22px;
        }
      }
    }

    .link-wrapper {
      margin-top: 28px;
      .learning {
        font-size: 20px;
        font-weight: 700;
        line-height: 24px;
        color: #fff;
        text-align: center;
      }

      .apps {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-column-gap: 20px;
        margin-top: 20px;

        .app-icon {
          width: 36px;
          height: 36px;
        }
      }
    }

    .download-btn-1 {
      background-color: #000;
      border-radius: 5px;
      margin-top: 70px;
      margin-bottom: 120px;
      height: 50px;
      display: flex;
      align-items: center;
      padding-left: 18px;
      padding-right: 27px;
      font-size: 16px;
      font-weight: 590;
      line-height: 19px;
      color: #fff;

      .sys-icon {
        width: 18px;
        height: 18px;

        &.android {
          margin-left: 4px;
          margin-right: 14px;
        }
      }
    }
  }
}
.networkErr {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .content-title {
    font-size: 24px;
    font-weight: 600;
    line-height: 28x;
    text-align: center;
    margin-bottom: 10px;
  }
  .content-des {
    width: 250px;
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    text-align: center;
    margin-bottom: 48px;
    color: #848484;
  }
  .content-btn {
    width: 180px;
    height: 44px;
    border-radius: 4px;
    background: #0093ff;
    border: none;
    font-size: 17px;
    font-weight: 600;
    text-align: center;
    color: #fff;
  }
}
</style>
